/**
 * Strip diacritics from a string for search matching.
 * "être" → "etre", "ça" → "ca", "déjà" → "deja"
 */
export function stripDiacritics(str) {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

/**
 * Normalise a string for dictionary search:
 * lowercase + strip diacritics + trim
 */
export function normaliseForSearch(str) {
  return stripDiacritics(str.toLowerCase().trim());
}
